import { useTenant } from '../contexts/TenantContext';

const ROLE_RANK = {
  creator: 0,
  agent: 1,
  agency_owner: 2,
  tenant_admin: 3,
  super_admin: 4,
};

/**
 * useRole(['agency_owner', 'tenant_admin']) → true if userRole is in the list
 * useRole('agency_owner') → also accepts a single role string
 * useRole({ atLeast: 'agent' }) → checks rank ≥ 'agent'
 */
export const useRole = (input) => {
  const { userRole } = useTenant();
  if (!userRole) return false;

  if (typeof input === 'string') return userRole === input;
  if (Array.isArray(input)) return input.includes(userRole);
  if (input && typeof input === 'object' && input.atLeast) {
    const target = ROLE_RANK[input.atLeast];
    const current = ROLE_RANK[userRole];
    if (target == null || current == null) return false;
    return current >= target;
  }
  return false;
};
